<div class="no-data-content" [style.min-height]="minHeight">
  <div class="no-data-item narrow">
    <svg-icon class="m-b-16" key="no-data"></svg-icon>
    <p>No data available for {{ dateLabel }}.</p>
    <p>Try a different time period or check back later for updates.</p>
  </div>
</div>
